import {
  PickupScheduleRegularDay,
  PickupScheduleSpecialDate,
  PickupScheduleTimeSlot
} from "./PickupCorporateScheduleConfig";
import {
  createInitialRegularDays,
  RegularDaySchedule
} from "@/app/ui/views/pickup/pickup-schedule-config/components/schedule-types";

export interface SpecialDateSchedule {
  date: string;
  slots: PickupScheduleTimeSlot[];
}

export function mapUiRegularDaysToEntity(
  days: RegularDaySchedule[]
): PickupScheduleRegularDay[] {
  return days.map(
    (day) =>
      new PickupScheduleRegularDay({
        day: day.day,
        checked: day.checked,
        times: day.slots.map((slot) => new PickupScheduleTimeSlot(slot))
      })
  );
}

export function mapEntityToUiRegularDays(
  days: PickupScheduleRegularDay[],
  fillMissingWithInitialSelection = true
): RegularDaySchedule[] {
  if (!days.length) {
    return createInitialRegularDays().map((day) => ({
      ...day,
      checked: fillMissingWithInitialSelection
    }));
  }

  return createInitialRegularDays().map((initialDay) => {
    const matchingDay = days.find((day) => day.day === initialDay.day);
    return {
      day: initialDay.day,
      checked: matchingDay
        ? matchingDay.checked
        : fillMissingWithInitialSelection,
      slots: matchingDay
        ? matchingDay.times
            .map((time) => ({ ...time }))
            .sort((a, b) => a.start.localeCompare(b.start))
        : []
    };
  });
}

export function mapUiSpecialDatesToEntity(
  dates: SpecialDateSchedule[]
): PickupScheduleSpecialDate[] {
  return dates.map(
    (date) =>
      new PickupScheduleSpecialDate({
        date: date.date,
        times: date.slots.map((slot) => new PickupScheduleTimeSlot(slot))
      })
  );
}

export function mapEntityToUiSpecialDates(
  dates: PickupScheduleSpecialDate[]
): SpecialDateSchedule[] {
  return dates.map((date) => ({
    date: date.date,
    slots: date.times.map((time) => new PickupScheduleTimeSlot(time))
  }));
}
